import styled from "@emotion/styled";
import Tabs from "@mui/material/Tabs";

export const Container = styled.div``;

export const StyledTabs = styled(Tabs)`
  min-block-size: auto;
  border-block-end: 1px solid #d7d7d7;
  & .MuiButtonBase-root {
    min-inline-size: auto;
    min-block-size: auto;
    padding-block: 12px 9px;
    padding-inline: 0;

    color: #888888;
    font-weight: 700;
    font-size: 16px;
    line-height: normal;
    text-align: center;

    &:not(:last-child) {
      margin-inline-end: 24px;
    }
  }

  & .Mui-selected {
    color: #000000;
  }

  & .MuiTabs-indicator {
    block-size: 3px;

    background-color: #4585ff;
  }
`;

export const TabPanelContainer = styled.div`
  block-size: 557px;

  overflow-y: auto;
`;

export const EmptySchedule = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  block-size: 100%;
  padding-inline: 30px;

  color: #a1a1a1;
  font-weight: 700;
  font-size: 16px;
  line-height: 18.75px;
  text-align: center;
`;
